import { createContext, Dispatch, SetStateAction } from 'react'

/**
 * APIKeyの初期値
 */
export const initialAPIKeyContext = ''

export const APIKeyContext = createContext<APIKeyContextProps>([
  initialAPIKeyContext,
  (): void => {
    // 初期値として空の関数を設定
  },
])

export type APIKeyContextProps = [string, Dispatch<SetStateAction<string>>]
